import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { JUNOContent } from '../../../types/global';
//import './style.scss';

interface GridImageProps {
  content: JUNOContent;
  index: number;
  ratio?: number;
  useField?: string;
  padding?: number;
  imageCoverOrContain?: 'contain' | 'cover';
  vars: {};
}

const GridImage: React.FC<GridImageProps> = ({
  content,
  ratio,
  useField = '',
  padding = 0,
  imageCoverOrContain = 'cover',
  vars = {},
}) => {
  const aContent = useMemo(() => App.INSTANCE.contentFactory(content), [content]);

  const altImageText = aContent.MetaData.filter(item => {
    return (
      item.Key === CrowdHub_App.META_IMAGE_ALT_TEXT ||
      item.Key === CrowdHub_App.META_IMAGE2_ALT_TEXT ||
      item.Key === CrowdHub_App.META_IMAGE3_ALT_TEXT
    );
  });

  const image = useField?.length > 0 ? aContent.RawData[useField] : aContent.Image;

  const onClick = () => {
    App.INSTANCE.routeToContent(aContent);

    App.INSTANCE.firehoseActivity(
      'Content',
      aContent.Id,
      App.INSTANCE.appRouter.lastRouteResolvedUrl(),
      App.INSTANCE.CurrentUser.Id,
      vars.buckets,
      'Click',
    );
    App.INSTANCE.reportActivity(
      aContent.Id,
      'Grid Item',
      'Clicked',
      App.INSTANCE.appRouter.lastRouteResolvedUrl(),
      null,
      null,
    );
  };

  return (
    <div
      role="link"
      aria-label={aContent.Name}
      className="grid_image"
      data-flip-title=""
      slot=""
      style={{ padding: padding }}
      onClick={onClick}
    >
      <div
        className="background_image_container ui_relative center_withmargins"
        data-flip-title=""
        slot=""
        style={ratio ? { paddingTop: `${100 * ratio}%` } : {}}
      >
        <div
          className={`background_image ${imageCoverOrContain}_absolute`}
          data-flip-title=""
          style={{
            backgroundImage: `url(${App.INSTANCE.getImageSrc(image)})`,
          }}
          slot=""
        ></div>
      </div>
    </div>
  );
};

export default GridImage;
